import { duration } from "moment";
import { Component } from "react";
import SimpleReactValidator from "simple-react-validator";
import { createNotification } from "../../../../helpers/Notification";
class ShopItemPopUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            detailName: this.props.detailName,
            duration: this.props.duration ? this.props.duration :'',
            serviceInterval: this.props.serviceInterval ? this.props.serviceInterval : "",
            nameError: '',
            sIntervalError: '',
            nameErrorStatus: true,
            sIntervalErrorStatus: true,
            durationErr: false,
            serviceIntervalErrorFlag:false,

            // dropdown to select either days or month
            dropDownList: [{
                id: 1,
                label: "Month",
                value: "month"

            },
            {
                id: 2,
                label: "Days",
                value: "days"

            }
            ]
        }
        // this.validator = new SimpleReactValidator();
        this.validator = new SimpleReactValidator({
            validators: {
                maxLength3: {
                    message: 'The Service Interval field cannot be greater then 3 digits.',
                    rule: (val, params, validator) => val.toString().length <= 3
                },
                // nonEmptyField:{
                //     message:'The duration field is required',
                //     rule:(val, params, validator) => val.toString().trim().length <= 3
                // }
            }
        });

    }

    // Method for Save Item Details-------------------------------
    saveItemDetails = (event) => {
        let name = event.target.detailName.value;
        let sInterval = event.target.serviceInterval.value;
        const { duration } = this.state;
        // if(name !== '' && name.trim().length === 0 || spCharector.test(name) || onlyNumbers.
        if (this.validator.allValid() && duration !== '0') {
            this.props.saveShopItem(name.trim(), sInterval.trim(), duration);
        } else {
            if (duration === "0") {
                this.setState({ durationErr: true });
                this.validator.showMessages();
                this.forceUpdate();
            }
            else {
                this.validator.showMessages();
                this.forceUpdate();
            }

        }

        event.preventDefault();
    }

    // Method for Update Item Details -----------------------------
    updateItemDetails = (event) => {
        // let name = event.target.detailName.value;
        // let sInterval = event.target.serviceInterval.value;
        const { duration,detailName,serviceInterval } = this.state;
        
        // if(name !== '' && name.trim().length === 0 || spCharector.test(name) || onlyNumbers.test(name) && !isNaN(name)){
        //     this.setState({nameError:"This is an invalid input",nameErrorStatus:true});
        // }else if(name === ''){
        //     this.setState({nameError:"Item name is required*",nameErrorStatus:true});
        // }else{
        //     this.setState({nameError:"",nameErrorStatus:false});
        // }

        // if(sInterval !== '' && sInterval.trim().length === 0 || spCharector.test(sInterval) || onlyNumbers.test(sInterval) && !isNaN(sInterval)){
        //     this.setState({sIntervalError:"This is an invalid input",sIntervalErrorStatus:true});
        // }else if(sInterval === ''){
        //     this.setState({sIntervalError:"Service interval is required*",sIntervalErrorStatus:true});
        // }else{
        //     this.setState({sIntervalError:"",sIntervalErrorStatus:false});
        // }
        // if(nameErrorStatus === false && sIntervalErrorStatus === false){
        //     this.props.updateShopItem(name.trim(),sInterval.trim());
        // }else if((name !== '' && name.trim().length !== 0 && !spCharector.test(name) && !onlyNumbers.test(name) && isNaN(name)) && (sInterval !== '' && sInterval.trim().length !== 0 && !spCharector.test(sInterval) && !onlyNumbers.test(sInterval) && isNaN(sInterval))){
        //     this.props.updateShopItem(name.trim(),sInterval.trim());
        // }``
        
        if (this.validator.allValid() && ( duration !== '0' && duration !== "")&&(serviceInterval!=="")) {
           
            this.props.updateShopItem(detailName.trim(), serviceInterval.trim(), duration);
        } else {

            if(serviceInterval==""){

            }
            if (duration === "0") {
                this.setState({ durationErr: true });
                this.validator.showMessages();
                this.forceUpdate();
            }
            else {
                
                this.validator.showMessages();
                this.forceUpdate();
            }
        }

        event.preventDefault();
    }

    // Onchange Method for Update Modal fields-------------------

    handleOnchange = (event) => {
        let spCharector = /[^\w\s]/gi;
        let onlyNumbers = /[0-9]/;

        if (event.target.name === "detailName") {
            if (event.target.value !== '' && event.target.value.trim().length === 0 || spCharector.test(event.target.value) || onlyNumbers.test(event.target.value) && !isNaN(event.target.value)) {
                this.setState({ nameError: "This is an invalid input", nameErrorStatus: true });
            } else if (event.target.value === '') {
                this.setState({ nameError: "Item name is required*", nameErrorStatus: true });
            } else {
                this.setState({ nameError: "", nameErrorStatus: false });
            }
        } else if (event.target.name === "serviceInterval") {
            if (event.target.value !== '' && event.target.value.trim().length === 0 || spCharector.test(event.target.value) || onlyNumbers.test(event.target.value) && !isNaN(event.target.value)) {
                this.setState({ sIntervalError: "This is an invalid input", sIntervalErrorStatus: true });
            } else if (event.target.value === '') {
                this.setState({ sIntervalError: "Service interval is required*", sIntervalErrorStatus: true });
            } else {
                this.setState({ sIntervalError: "", sIntervalErrorStatus: false });
            }
        }
        if (event.target.name === "duration") {
            if (event.target.value === "0") {
                this.setState({ durationErr: true }, () => {
                    this.checkDurationIsValid();
                });
            } else {
                this.setState({ durationErr: false });
            }
        }

        this.setState({
            [event.target.name]: event.target.value
        });
    }


    checkDurationIsValid = () => {
        const { serviceInterval, duration } = this.state;

        if (duration === "month") {
            if (serviceInterval > 12) {
                createNotification("error", "Duration cannot be greater then 12 months.");
                this.setState({ duration: "0", serviceInterval: "" })
            }
        }
        else if (duration === "days") {
            if (serviceInterval > 365) {
                createNotification("error", "Duration cannot be greater then 365 days.");
                this.setState({ duration: "0", serviceInterval: "" })
            }
        }
    }

    //---------------------------------------------------------//

    render() {
        



        const { dropDownList } = this.state;
        const { closeModal, modalStatus } = this.props;
        return (
            <div>
                {modalStatus === "add" ?
                    // ADD MODAL FOR ITEM DETAILS STARTS HERE:-----
                    (<form onSubmit={this.saveItemDetails}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title mt-0 text-dark fw-bold text-center" id="myModalLabel"> Add item </h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closeModal(false)} ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3 accordWrap">
                                    <div className="row" >
                                        <div className="col-md-4">
                                            <label className="col-md-4">Item Name</label>
                                            <input autoComplete="off" type="text" className="form-control col-md-2" placeholder="Please enter the item name." name="detailName" onChange={(e) => { this.handleOnchange(e) }} />
                                            {this.validator.message('Item name', this.state.detailName, 'required|max:100', { className: 'text-danger' })}
                                            {/* <p style={{color:"red"}}>{this.state.nameError}</p> */}
                                        </div>
                                        <div className="col-md-4">
                                            <label className="col-md-4">Service Interval</label>
                                            <input autoComplete="off" type="number" min={0} className="form-control col-md-2" placeholder="Please enter service interval." name="serviceInterval" value={this.state.serviceInterval} onChange={(event) => {
                                                const value = event.target.value;
                                                if (/^\d*$/.test(value)) { // allows only digits
                                                    this.handleOnchange(event)
                                                }
                                            }}
                                                onKeyDown={(event) => {
                                                    if ([".", "e", "E", "-"].includes(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }} />
                                            {this.validator.message('Service Interval', this.state.serviceInterval, 'required|integer|maxLength3', { className: 'text-danger' })}


                                        </div>
                                        <div className="col-md-4">
                                            <label className="col-md-8">Duration</label>
                                            <div className="project-filter-dropdown d-flex align-items-center">
                                                <select className="form-select  calendar-drop-down-btn"
                                                    onChange={(event) => this.handleOnchange(event)}
                                                    value={this.state.duration}
                                                    name="duration">
                                                    <option value="0">Select  Duration</option>
                                                    {dropDownList.length && dropDownList.map((itemData) => {
                                                        return (
                                                            <option value={itemData.value}>
                                                                {itemData.label}
                                                            </option>
                                                        )
                                                    })}
                                                </select>

                                            </div>

                                            {/* {durationError !== '' ?
                                                <p style={{ color: "red" }}>{durationError}</p>
                                                :
                                                <></>} */}
                                            {this.validator.message('Duration', this.state.duration, 'required', { className: 'text-danger' })}
                                            {this.state.durationErr ? <p className="text-danger">The duration field is required .</p> : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer justify-content-center">
                                <button type="button" className="btn btn-danger fw-bold" data-bs-dismiss="modal" aria-label="Close" onClick={() => closeModal(false)} >Cancel</button>
                                <button className="btn btn-primary fw-bold"> Save </button>
                            </div>
                        </div>
                    </form>)
                    // ADD MODAL FOR ITEM DETAILS ENDS HERE:-----
                    :
                    // UPDATE MODAL FOR ITEM DETAILS STARTS HERE:-------
                    (<form onSubmit={this.updateItemDetails}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title mt-0 text-dark fw-bold text-center" id="myModalLabel"> Update item </h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closeModal(false)} ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3 accordWrap">
                                    <div className="row" >
                                        <div className="col-md-4">
                                            <label className="col-md-4">Item Name</label>
                                            <input autoComplete="off" type="text" className="form-control col-md-2" placeholder="Please enter the item name." name="detailName" value={this.state.detailName} onChange={(e) => { this.handleOnchange(e) }} />
                                            {this.validator.message('Item name', this.state.detailName, 'required|max:100', { className: 'text-danger' })}
                                            {/* <p style={{color:"red"}}>{this.state.nameError}</p> */}
                                        </div>
                                        <div className="col-md-4">
                                            <label className="col-md-4">Service Interval</label>
                                            <input autoComplete="off" type="number" min={0} className="form-control col-md-2" placeholder="Please enter service interval." name="serviceInterval" value={this.state.serviceInterval} onChange={(event) => {
                                                const value = event.target.value;
                                                if (/^\d*$/.test(value)) { // allows only digits
                                                    this.handleOnchange(event)
                                                }
                                            }}
                                                onKeyDown={(event) => {
                                                    if ([".", "e", "E", "-"].includes(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }} />
                                            {this.validator.message('Service Interval', this.state.serviceInterval, 'required|integer|maxLength3', { className: 'text-danger' })}

                                            {/* <p style={{color:"red"}}>{this.state.sIntervalError}</p> */}
                                        </div>
                                        <div className="col-md-4">
                                            <label className="col-md-8">Duration</label>
                                            <div className="project-filter-dropdown d-flex align-items-center">
                                                <select className="form-select  calendar-drop-down-btn"
                                                    onChange={(event) => this.handleOnchange(event)}
                                                    value={this.state.duration}
                                                    name="duration">
                                                    <option value="0">Select  Duration</option>
                                                    {dropDownList.length && dropDownList.map((itemData) => {
                                                        return (
                                                            <option value={itemData.value}>
                                                                {itemData.label}
                                                            </option>
                                                        )
                                                    })}
                                                </select>

                                            </div>

                                            {/* {durationError !== '' ?
                                                <p style={{ color: "red" }}>{durationError}</p>
                                                :
                                                <></>} */}
                                            {this.validator.message('Service Interval', this.state.duration, 'required', { className: 'text-danger' })}
                                            {this.state.durationErr ? <p className="text-danger">The duration field is required .</p> : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer justify-content-center">
                                <button type="button" className="btn btn-danger fw-bold" data-bs-dismiss="modal" aria-label="Close" onClick={() => closeModal(false)} > Cancel</button>
                                <button className="btn btn-primary fw-bold"> Update </button>
                            </div>
                        </div>
                    </form>)
                    // UPDATE MODAL FOR ITEM DETAILS ENDS HERE:-----
                }
            </div>
        )
    }
}

export default ShopItemPopUp;